import { useI18n } from "../i18n";
import Aboutphoto from '../assets/about.jpg'
const AboutStory = () => {
    const { about } = useI18n();

    return (
        <>
            {/* Existing About Story */}
            <section className=" px-6 py-20 md:px-12 md:py-28">
                <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2 lg:gap-20">
                    <div className="relative">
                        <div className="absolute -left-4 -top-4 h-32 w-32 rounded-tl-3xl border-l-2 border-t-2 border-sky-400/70" />

                        <img
                            src={Aboutphoto}
                            alt={about.storyImage}
                            loading="lazy"
                            decoding="async"
                            className="relative h-[320px] w-full rounded-2xl object-cover sm:h-[420px]"
                        />

                        <div className="absolute -bottom-5 -right-4 hidden h-28 w-28 rounded-br-3xl border-b-2 border-r-2 border-sky-400/70 sm:block" />
                    </div>

                    <div className="rounded-2xl
                  border border-white/80 bg-white/80 p-5
                  shadow-sm backdrop-blur-md">
                        <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-sky-700 sm:text-sm">
                            <span className="h-px w-8 bg-sky-500" />
                            {about.storyEyebrow}
                        </p>

                        <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 md:text-5xl">
                            {about.storyTitle}
                        </h2>

                        <p className="mt-6 text-base leading-8 text-slate-600">
                            {about.storyParagraph1}
                        </p>

                        <p className="mt-4 text-base leading-8 text-slate-600">
                            {about.storyParagraph2}
                        </p>

                        <div className="mt-8 flex items-start gap-4 border-l-2 border-sky-500 pl-5">
                            <div>
                                <h3 className="font-bold text-slate-900">
                                    {about.missionTitle}
                                </h3>

                                <p className="mt-2 leading-7 text-slate-600">
                                    {about.missionText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutStory;